// const width = window.innerWidth <= 768 ? "55rem" : "80rem";
const width =  "clamp(55rem, 98vw, 70rem)";
const height = window.innerWidth <= 768 ? 400 : 500;
const text =  {fontSize: 'clamp(6px, calc(7px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)'};
const odds =
{
  textAlign: "center",
  backgroundColor: "black",
  color: "white",
  fontSize: 'clamp(10px, calc(8px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)',
};

const cells =
{
  textAlign: "center",
  backgroundColor: "black",
  color: "white",
  border: 0,
  fontSize: 'clamp(12px, calc(12px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)',

};


const column_1 =
{
  textAlign: "center",
  backgroundColor: "black",
  color: "white",
  border: 0,
  fontSize: 'clamp(8px, calc(12px + (4) * ((100vw - 300px) / (1200 - 320))), 20px)',

};

const analysis = {
  fontSize: 'clamp(12px, calc(12px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)',
  textAlign: "left",  
  paddingLeft: "1rem",
  marginBottom: "2vh",
  color: 'white'
};


const suggested =
{
  textAlign: "center",
  backgroundColor: "black",
  color: "green",
  fontSize: 'clamp(10px, calc(8px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)',
  fontWeight: 'bold',

};


const result =
{
  textAlign: "center",
  backgroundColor: "black",
  color: "green",
  fontSize: 'clamp(10px, calc(8px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)',
  fontWeight: 'bold',

};

const main =
{
  backgroundColor: "black",
  color: "white",
  width: width
}

const cardbutton =
{
  // textAlign: "center", 
  backgroundColor: "black",
  color: "white",
  width: width,
  borderColor: "white",
  borderWidth: 1,
  borderStyle: "solid",
  padding: 20,
  fontSize: 'clamp(12px, calc(12px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)',
}

const cardbutton_solo =
{
  // textAlign: "center", 
  backgroundColor: "black",
  color: "white",
  width: width,
  borderColor: "white",
  borderWidth: 1,
  borderStyle: "solid",
  padding: 20,
  fontSize: 'clamp(12px, calc(12px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)',
  marginLeft: '1rem',
}

// The day-nav strip under a slate: three equal buttons spanning exactly the
// width of the fixture cards above them, so they read as the foot of the list
// rather than as a separate element that happens to sit nearby.
//
// It replaces `cardbutton_half`, which was a *half*-width button (49vw) placed
// in three `xs={4}` columns — each card was ~1.5x its own column, so the row ran
// off the right edge of the viewport and its 1rem side margins meant no two
// buttons started at the same offset. A grid states the intent (three equal
// tracks) instead of relying on a fixed width agreeing with a column count.
const daynav =
{
  width: width,
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "1rem",
  marginTop: "1.5rem",
}

const cardbutton_third =
{
  backgroundColor: "black",
  color: "white",
  // 100% of one grid track. The track, not the button, owns the arithmetic.
  width: "100%",
  borderColor: "white",
  borderWidth: 1,
  borderStyle: "solid",
  padding: 20,
  fontSize: 'clamp(12px, calc(12px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)',
}


// The middle track of the day-nav: Refresh stacked over Today (Brian's call,
// 2026-09-14). Two flatter buttons that together fill the same track height the
// Previous/Next buttons do -- the grid row stretches every track to the tallest,
// and flex:1 splits it evenly. `width: 100%` for the same reason as
// `cardbutton_third`: the track owns the arithmetic, not the button.
const daynav_stack =
{
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
}

const cardbutton_flat =
{
  ...cardbutton_third,
  flex: 1,
  padding: "6px 12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}


const comment =
{
  // textAlign: "center", 
  backgroundColor: "black",
  color: "white",
  width: `calc(${width} - 3rem)`,
  borderColor: "white",
  borderWidth: 1,
  borderStyle: "solid",
  padding: 20
}

const star = {
  width: 'clamp(8px, 4vw, 24px)',
  height: 'auto',
  color: 'white'  // This will set the fill color of the star
}

const commentCard = {
  marginBottom: '10px',
  backgroundColor: 'black',
  color: 'white',
  borderColor: 'white',
  borderWidth: 1,
  borderStyle: 'solid',
  padding: 20,
};

const commentHeader = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '5px',
};

const username = {
  fontWeight: 'bold',
  marginRight: '10px',
  color: '#4e79a7', // A blue shade, you can adjust this color
};

const score = {
  color: '#888',
  marginRight: '10px',
};

const timestamp = {
  color: '#888',
  fontSize: '0.8em',
};


const sectionStyle = {
  minHeight: "100vh",
  scrollSnapAlign: "start",
  scrollSnapStop: "always",
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  justifyContent: "start",
};


const desktopMain = {
  ...main,
  maxWidth: '1400px',
  margin: '0 auto',
}

const desktopGrid = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '20px',
  width: '100%',
}

const desktopGridThree = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
  gap: '20px',
  width: '100%',
}

const sectionStyleDesktop = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'start',
}

// Applied to a rendered em-dash so absence reads as absence rather than as a
// value that happens to be dash-shaped.
const unknown = {
  color: 'rgba(255, 255, 255, 0.45)',
}

// The draw row of a three-way market. A draw has a moneyline and cannot have a
// spread, a total or a team name — those cells are not *missing* data the way an
// unpriced market is, they are questions the market never asks. Rendering them
// as em-dashes said "we do not know", which is a different and wrong claim, and
// boxing them made the row assert a shape it does not have.
//
// So the inapplicable cells lose their borders and their content entirely
// (drawBlank), and the two real cells drop only their bottom edge (drawCell), so
// the row reads as two open channels hanging off the line under Away rather than
// as a third full row of the table.
const drawBlank = {
  border: 0,
  backgroundColor: 'black',
}

const drawCell = {
  borderBottom: 0,
}

// Bootstrap 5's `.table-bordered > :not(caption) > *` sets `border-width: 1px 0`
// on the *row*, not only on its cells — so zeroing every td's bottom edge still
// left one line running the full width of the table underneath the draw. The row
// has to be unset too, and this is the only reason `drawRow` exists.
const drawRow = {
  borderBottom: 0,
}

// A result box whose outcome we do not know. Must be visually distinct from the
// "miss" box, which is transparent with a solid border — otherwise unknown
// history renders as ten losses, which is the bug this is fixing.
const unknownBox = {
  backgroundColor: 'transparent',
  borderStyle: 'dashed',
  borderColor: 'rgba(255, 255, 255, 0.35)',
}

export const styles = {
  unknown: unknown,
  unknownBox: unknownBox,
  drawBlank: drawBlank,
  drawCell: drawCell,
  drawRow: drawRow,
  Odds: odds,
  Suggested: suggested,
  result: result,
  main: main,
  Cells: cells,
  cardbutton: cardbutton,
  cardbutton_solo: cardbutton_solo,
  cardbutton_third: cardbutton_third,
  daynav: daynav,
  daynav_stack: daynav_stack,
  cardbutton_flat: cardbutton_flat,
  comment: comment,
  star: star,
  commentCard: commentCard,
  commentHeader: commentHeader,
  username: username,
  score: score,
  timestamp: timestamp,
  column_1: column_1,
  sectionStyle: sectionStyle,
  text: text,
  analysis: analysis,
  height: height,
  desktopMain: desktopMain,
  desktopGrid: desktopGrid,
  desktopGridThree: desktopGridThree,
  sectionStyleDesktop: sectionStyleDesktop,
}